import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { Page } from '@frontend/vanilla/core';
import { AuthDetailsStore, CustomHttpClientService, PaymentsAuthenticationService, PaymentsCustomApiService } from '@payments/common-utils';

@Injectable({
    providedIn: 'root',
})
export class BetslipQdApiService extends PaymentsCustomApiService {
    constructor(
        customHttpClientService: CustomHttpClientService,
        authService: PaymentsAuthenticationService,
        page: Page,
        injector: Injector,
        authDetailsStore: AuthDetailsStore,
    ) {
        super(customHttpClientService, authService, page, injector, authDetailsStore);
    }

    override getHttpHeaders(type?: string): HttpHeaders {
        const headers = super.getHttpHeaders(type);

        // Ensure 'auth-code' is always present
        return headers.set('auth-code', this.authDetailsStore.getAuthDetails().authCode);
    }
}
